import React from "react";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import GavelIcon from "@mui/icons-material/Gavel";
import DescriptionIcon from "@mui/icons-material/Description";

export default function ExpedienteDetalleBreadcrumb({ tipo, data }) {
    const navigate = useNavigate();
    const location = useLocation();

    const icon =
        tipo === "judicial" ? (
            <GavelIcon fontSize="small" style={{ verticalAlign: "middle", marginRight: 2, color: "#fff" }} />
        ) : (
            <DescriptionIcon fontSize="small" style={{ verticalAlign: "middle", marginRight: 2, color: "#fff" }} />
        );

    return (
        <Breadcrumbs aria-label="breadcrumb" style={{ marginBottom: 12 }}>
            <Link
                color="inherit"
                onClick={() => navigate("/")}   // << antes: "/dashboard"
                style={{
                    cursor: "pointer",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    color: "#fff",
                    textShadow: "0 1px 4px #2228"
                }}
            >
                <HomeIcon fontSize="small" style={{ marginRight: 4, color: "#fff" }} />
                Inicio
            </Link>

            <Link
                color="inherit"
                onClick={() => {
                    if (location.state && location.state.tab !== undefined) {
                        navigate("/expedientes", {
                            state: { tab: location.state.tab, filtros: location.state.filtros || undefined }
                        });
                    } else {
                        navigate("/expedientes");
                    }
                }}
                style={{
                    cursor: "pointer",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    color: "#fff",
                    textShadow: "0 1px 4px #2228"
                }}
            >
                <FolderOpenIcon fontSize="small" style={{ marginRight: 4, color: "#fff" }} />
                Expedientes {tipo === "judicial" ? "Judiciales" : "Administrativos"}
            </Link>

            <Typography
                color="text.primary"
                style={{
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                    color: "#fff",
                    textShadow: "0 1px 4px #2228"
                }}
            >
                {icon}
                {tipo === "judicial"
                    ? data.autos_1_instancia || "Expediente Judicial"
                    : data.nro_expediente || "Expediente Administrativo"}
            </Typography>
        </Breadcrumbs>
    );
}
